/*
 * Ma Belle Verrière : affichage du prix du simulateur avec le nouveau serveur de prix (api.mabelleverriere.fr).
 * Le serveur répond « 1234 » (prix TTC), « apartir 1234 » (prix sans les options en supplément) ou « devis ».
 * Les scripts du simulateur (verriere-customizer*.js) n'affichent que des nombres : ce script passe juste après eux
 * et écrit « à partir de … » ou « sur devis » à la place. Aucun prix ni aucun calcul ici.
 * À charger après jQuery et les scripts du simulateur, sur les pages « Créer ma verrière ».
 */
(function ($) {
  if (!$ || !$.fn) { return; }
  var ADRESSE = /^https:\/\/api\.mabelleverriere\.fr\/p(-rachel-test)?\//;
  var euros = function (n) {
    try { return new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 }).format(n); } catch (e) { return String(n); }
  };
  var NOTE = 'display:block;font-size:.8em;font-weight:400;opacity:.8;margin-top:2px';

  function affiche(etat, prix) {
    window.MBV_ETAT_PRIX = etat;   // lu par mbv-devis.js : 'prix' = devis en libre-service, sinon demande obligatoire
    var html;
    if (etat === 'prix') {
      html = '<b>Prix TTC :</b> <span class="js-value-price">' + euros(prix) + '</span> €';
    } else if (etat === 'apartir') {
      html = '<b>Prix TTC :</b> à partir de <span class="js-value-price">' + euros(prix) + '</span> €' +
        '<small style="' + NOTE + '">Options en supplément chiffrées dans votre devis gratuit</small>';
    } else if (etat === 'devis') {
      html = '<b>Prix :</b> <span class="js-value-price">sur devis</span>' +
        '<small style="' + NOTE + '">Cette configuration est chiffrée par notre atelier : demandez votre devis gratuit</small>';
    } else {
      html = '<b>Prix :</b> <span class="js-value-price">sur devis</span>' +
        '<small style="' + NOTE + '">Le prix ne peut pas s’afficher pour le moment : demandez votre devis gratuit</small>';
    }
    $('.simulateur-price').html(html);
    // prix promotionnel éventuel (−25 % des liens partenaires) : seulement quand il y a un vrai prix
    // (le bloc n'est masqué ici que s'il était visible, et réaffiché au prix suivant : sa visibilité reste celle du thème)
    $('.js-value-price-promo').each(function () {
      var bloc = $(this).parent();
      if (etat === 'prix') {
        $(this).text(euros(Math.round(prix * 0.75)));
        if (bloc.data('mbvMasque')) { bloc.show().data('mbvMasque', false); }
      } else if (bloc.is(':visible')) {
        bloc.hide().data('mbvMasque', true);
      }
    });
  }

  // passe après chaque réponse du serveur de prix (les scripts du simulateur ont déjà écrit leur nombre)
  $(document).ajaxComplete(function (evt, xhr, reglages) {
    if (!reglages || !ADRESSE.test(String(reglages.url || ''))) { return; }
    if (xhr.statusText === 'abort') { return; }          // demande remplacée par un réglage plus récent
    var t = String(xhr.responseText || '').replace(/^\s+|\s+$/g, ''), m;
    if (xhr.status === 200 && /^\d+$/.test(t)) { affiche('prix', +t); }
    else if (xhr.status === 200 && (m = /^apartir (\d+)$/.exec(t))) { affiche('apartir', +m[1]); }
    else if (xhr.status === 200 && t === 'devis') { affiche('devis'); }
    else { affiche('indisponible'); }
  });
})(window.jQuery);
